import { FC } from "react";
import { useLocation } from "react-router-dom";
export interface FleetCardProps {
  className?: string;
  data?: any;
  size?: "default" | "small";
  simpleImg?: boolean;
  onClick?: any;
}

const FleetCard: FC<FleetCardProps> = ({
  size = "default",
  className = "",
  data,
  simpleImg = false,
  onClick,
}) => {
  const {
    fleet_photos,
    name,
    color,
    seats,
    avg_car_price_per_day,
    thumbnail_photo_url,
  } = data!;
  const location = useLocation();

  const renderSliderGallery = () => {
    return (
      <div className="relative w-full">
        {/* {simpleImg ? ( */}
        <img
          src={
            fleet_photos && fleet_photos.length > 0
              ? `https://fleet-management-images-upload-be.s3.amazonaws.com/${encodeURIComponent(
                  thumbnail_photo_url
                )}`
              : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
          }
          alt="name"
          className="h-[200px] object-cover w-full"
        />
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <h2
              className={`font-medium capitalize w-full ${
                size === "default" ? "text-lg" : "text-base"
              }`}
            >
              <div
                className="max-w-full"
                style={{ width: "100%", maxWidth: "100%" }}
              >
                <span
                  className="block truncate text-text-color whitespace-nowrap overflow-hidden overflow-ellipsis"
                  style={{ textOverflow: "ellipsis" }}
                >
                  {name}
                </span>
              </div>
            </h2>
          </div>

          <span className="text-text-color text-sm">
            <span className="font-semibold">{seats}</span> seats{" "}
            <span className="font-semibold">{color}</span> color
          </span>
        </div>
        <div className="w-14 border-b border-secondary-100 "></div>
        <div className="flex justify-between items-center">
          <span className="text-base font-semibold text-text-color">
            {avg_car_price_per_day ? "$" + avg_car_price_per_day : "$" + 0}

            {` `}
            {size === "default" && (
              <span className="text-sm text-text-color font-normal">/day</span>
            )}
          </span>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-StayCard group relative rounded-md border border-secondary-100 overflow-hidden will-change-transform hover:shadow-xl transition-shadow ${className}${
        location.pathname === "/available-car" ? "cursor-pointer" : ""
      }`}
      data-nc-id="StayCard"
      onClick={onClick}
    >
      {renderSliderGallery()}
      {renderContent()}
    </div>
  );
};

export default FleetCard;
